// Show drop down menu in Mobile size
// mobileMenu = document.getElementsByClassName('mobile-menu-myaccount')[0]

// if (typeof mobileMenu != 'undefined' && mobileMenu != null) {
//   mobileMenu.addEventListener('click', displayMobileMenu)
//   function displayMobileMenu() {
//     menuTag = document.getElementsByClassName('woocommerce-MyAccount-navigation')[0]
//     menuTag.classList.toggle('toggle-menu')
//   }
// }

jQuery(document).ready(function ($) {
  if (typeof Storage !== 'undefined' && sessionStorage.cb_user_b) {
    $('div#lk-wc-balance-menu').replaceWith(sessionStorage.cb_user_b)
  } else {
    $.ajax({
      url: cashbackUser.wpAjax + '/?lkwc-balance-ajax=balance',
      type: 'POST',
      success: function (data) {
        if (data && data.fragments) {
          $.each(data.fragments, function (key, value) {
            $(key).replaceWith(value)

            if (typeof Storage !== 'undefined') {
              sessionStorage.cb_user_b = value
            }
          })
        }
      },
    })
  }

  // Anchor link for nav
  if ($('.navigation-profile').length > 0) {
    $('.navigation-profile a').on('click', function () {
      $(window).scrollTop(0)
    })
  }
})

// Load "dateFormatting" function in signup popup
document.addEventListener('datepickerBirthdate', function () {
  var getBirthdateInput = document.getElementById('pure-header').getElementsByClassName('mx-input')
  document.addEventListener('keyup', function (e) {
    var birthdate = getBirthdateInput[0]
    dateFormatting(birthdate, e)
  })
})

// Load "dateFormatting" function in user profile page
document.addEventListener('DOMContentLoaded', function () {
  var birthdate = document.getElementsByClassName('mx-input')[0]
  if (typeof birthdate != 'undefined' && birthdate != null) {
    birthdate.addEventListener('keyup', function (e) {
      dateFormatting(birthdate, e)
    })
  }
})

// Automatically Adding "/" on birthdate field
function dateFormatting(birthdate, e) {
  if (typeof birthdate != 'undefined' && birthdate != null) {
    if (e.which !== 8) {
      var numChars = birthdate.value.length
      if (numChars === 2 || numChars === 5) {
        var thisVal = birthdate.value
        thisVal += '/'
        birthdate.value = thisVal
      }
    }
  }
}

// Prevent scrolling when modal is open (signup modal)
document.addEventListener('preventScrolling', (event) => {
  var x = window.scrollX
  var y = window.scrollY
  window.onscroll = function () {
    window.scrollTo(x, y)
  }
})

// Prevent scrolling when modal is open (Register payment modal)
document.addEventListener('DOMContentLoaded', function () {
  // we have 2 ".open-modal" / (for desktop and mobile)
  var openModal = document.querySelectorAll('.open-modal')
  for (var i = 0; i < openModal.length; i++) {
    openModal[i].addEventListener('click', (event) => {
      document.documentElement.style.overflow = 'hidden'
      var registerCardPopup = document.getElementById('user-cards-box')
      var close = registerCardPopup.getElementsByClassName('puremodal__button--dismiss')[0]
      close.addEventListener('click', (event) => {
        document.documentElement.style.overflow = 'auto'
      })
    })
  }
})

// Fold out text in Register card
document.addEventListener('paymentloaded', (event) => {
  var maxLength = 290
  jQuery('.term-condition-register-card label span').each(function () {
    var myStr = jQuery(this).text()
    if (jQuery.trim(myStr).length > maxLength) {
      var newStr = myStr.substring(0, maxLength)
      var removedStr = myStr.substring(maxLength, jQuery.trim(myStr).length)
      jQuery(this).empty().html(newStr)
      jQuery(this).append(' <a href="javascript:void(0);" class="read-more">Læs mere...</a>')
      jQuery(this).append('<span class="more-text">' + removedStr + '</span>')
    }
  })
  jQuery('.read-more').click(function () {
    jQuery(this).siblings('.more-text').contents().unwrap()
    jQuery(this).remove()
  })
})

function setRedirectUrl() {
  const elems = document.querySelectorAll('.redirect_url a')
  if (!elems.length) return

  elems.forEach((elem) => {
    const redirect = window.location.href
    const url = new URL(elem.href)
    url.searchParams.set('redirect', redirect)
    elem.setAttribute('href', url.toString())
    elem.setAttribute('target', '_blank')
  })
}

document.addEventListener('DOMContentLoaded', setRedirectUrl)

function setClaimRedirectUrl() {
  const redirectElems = document.querySelectorAll('.redirect_claim_url a, a.redirect_claim_url')
  if (!redirectElems.length) {
    return
  }
  const userID = Cookies.get('cashback_user_id')
  const currentPath = window.location.pathname
  if (!userID) {
    redirectElems.forEach((elem) => {
      const loginUrl = new URL(cashbackUser.login_url)
      loginUrl.searchParams.set('redirect', currentPath)
      elem.setAttribute('href', loginUrl.toString())
    })
  } else {
    return
  }
}


function setClaimRedirectUrlFaq() {
  const redirectElems = document.querySelectorAll('.redirect_claim_url_faq a, a.redirect_claim_url_faq')
  if (!redirectElems.length) {
    return
  }
  const userID = Cookies.get('cashback_user_id')
  const currentPath = "/min-konto/#/claim-cashback"
  if (!userID) {
    redirectElems.forEach((elem) => {
      const loginUrl = new URL(cashbackUser.login_url)
      loginUrl.searchParams.set('redirect', currentPath)
      elem.setAttribute('href', loginUrl.toString())
    })
  } else {
    return
  }
}

document.addEventListener('DOMContentLoaded', setClaimRedirectUrl)
document.addEventListener('DOMContentLoaded', setClaimRedirectUrlFaq)

import Cookies from 'js-cookie'

function setTravelLinkAttributes() {
  const elems = document.querySelectorAll('.travellink a, a.travellink')
  if (!elems.length) return

  elems.forEach((elem) => {
    const userID = Cookies.get('cashback_user_id')
    const publisher = cashbackUser.publisher
    const currentPath = window.location.pathname

    if (!userID) {
      const loginUrl = new URL(cashbackUser.login_url)
      loginUrl.searchParams.set('redirect', currentPath)
      elem.setAttribute('href', loginUrl.toString())
    } else {
      const url = new URL(elem.href)
      url.searchParams.set('userID', userID)
      url.searchParams.set('affiliateID', publisher)
      elem.setAttribute('href', url.toString())
      elem.setAttribute('target', '_blank')
    }
  })
}

document.addEventListener('DOMContentLoaded', setTravelLinkAttributes)
function setCustomLinkAttributes(className) {
  const links = document.querySelectorAll(`.${className}`)
  if (!links.length) return

  const userID = Cookies.get('cashback_user_id')
  const publisher = cashbackUser.publisher

  const cashbackTravelLink = 'https://cashbacktravel.dk/'

  links.forEach((link) => {
    const originalHref = link.getAttribute('href')

    if (userID) {
      const url = new URL(cashbackTravelLink)
      url.searchParams.set('userID', userID)
      url.searchParams.set('affiliateID', publisher)
      link.setAttribute('href', url.toString())
    } else {
      link.setAttribute('href', originalHref)
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  setCustomLinkAttributes('Customlink') // Replace 'Customlink' with the actual class name you want to target
})
